<script>
import {
	h,
} from 'vue';
export default {
	name: 'RenderHtml',
	props: {
		html: {
			required: true,
			type: String
		}
	},

	/**
	 * @returns {object}
	 */
	render () {
		const render = {
			template: '<div>' + this.html + '</div>',
		};

		return h(render);
	}
};
</script>

